const StripeFormStatusTranslator = (status: string) => {
    switch (status) {
        case 'requires_payment_method':
            return {
                message: 'Crikey! Your payment was not successful, please try again.',
                show: true,
                colour: 'red',
            };
        case 'requires_confirmation':
            return {
                message: 'Crikey! Your payment requires confirmation.',
                show: true,
                colour: 'orange',
            };
        case 'requires_action':
            return {
                message: 'Crikey! Your payment requires action.',
                show: true,
                colour: 'orange',
            };
        case 'processing':
            return {
                message: 'Crikey! Your payment is processing.',
                show: true,
                colour: 'orange',
            };
        case 'succeeded':
            return {
                message: 'Crikey! Your payment was successful.',
                show: true,
                colour: 'green',
            };
        default:
            return {
                message: 'Crikey! An unexpected error occurred.',
                show: true,
                colour: 'red',
            };
    }
};

export default StripeFormStatusTranslator;
